import { render, staticRenderFns } from "./AddCategoryPage.vue?vue&type=template&id=dcfa4e1a&scoped=true&"
import script from "./AddCategoryPage.vue?vue&type=script&lang=js&"
export * from "./AddCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoryPage.vue?vue&type=style&index=0&id=dcfa4e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfa4e1a",
  null
  
)

export default component.exports